<p-select
  fluid
  id="emissionFactor"
  [options]="factorOptions"
  [(ngModel)]="selectedValue"
  (onChange)="onChange($event)"
  [filter]="true"
  filterBy="Code"
  placeholder="Seleccione un factor de emisión"
  optionValue="Id"
  size="small"
  appendTo="body"
  class="sm-select">
  <ng-template #selectedItem let-selectedOption>
    @if (selectedOption) {
      <div class="flex flex-col w-full gap-0.5">
        <span class="text-sm! leading-[1.2] line-clamp-2">{{ getTranslatedCode(selectedOption.Code) }}</span>
        <div class="flex flex-row items-start justify-between">
          <span class="text-xs!">{{ selectedOption.Date.Version }}</span>
          <app-factor-select-country
            [countryIso2]="selectedOption.Location.Country"
            [stateName]="selectedOption.Location.City">
          </app-factor-select-country>
        </div>
      </div>
    }
  </ng-template>
  <ng-template let-item #item>
    <div class="flex flex-col w-full gap-0.5">
      <span class="text-sm! leading-[1.2] break-words whitespace-normal">{{ getTranslatedCode(item.Code) }}</span>
      <div class="flex flex-row items-start justify-between">
        <span class="text-xs!">{{ item.Date.Version }}</span>
        <app-factor-select-country
          [countryIso2]="item.Location.Country"
          [stateName]="item.Location.City">
        </app-factor-select-country>
      </div>
    </div>
  </ng-template>
</p-select>